import { VStack } from '@chakra-ui/react';
import React from 'react';

import { Box, Typography } from 'shared';

type ScheduledForWrapperProps = {
  divider: string;
  children: React.ReactNode;
};

export const ScheduledForWrapper = ({
  divider,
  children,
}: ScheduledForWrapperProps) => (
  <VStack gap=".5rem">
    {divider && (
      <Box textAlign="center" h={8} p={2}>
        <Typography
          type="small"
          color="gray"
          fontWeight="regular"
        >{`Scheduled for ${divider}`}</Typography>
      </Box>
    )}
    {children}
  </VStack>
);
